import React from "react";
import { FormControlLabel, Checkbox } from "@mui/material";
import { ArrowDown2 } from "iconsax-react";
import {
  ChildAccordion as StyledChildAccordion,
  ChildAccordionSummary,
  ChildAccordionDetails,
  SectionTitle,
} from "./styles";
import { ChildAccordionProps } from "../../types";
import { CheckboxGroup } from "../CheboxGroup";
import { useTranslation } from "react-i18next";

export const ChildAccordion = ({
  title,
  expanded,
  onToggle,
  fieldGroups,
  onSelectAll,
  isAllSelected,
  isPartiallySelected,
}: ChildAccordionProps) => {
  const { t: translate } = useTranslation();

  return (
    <StyledChildAccordion elevation={0} expanded={expanded} onChange={onToggle}>
      <ChildAccordionSummary expandIcon={<ArrowDown2 />}>
        <SectionTitle>{title}</SectionTitle>
        <FormControlLabel
          control={
            <Checkbox
              checked={isAllSelected}
              indeterminate={isPartiallySelected}
              onChange={onSelectAll}
            />
          }
          label={translate("selectAll")}
          onClick={(e) => e.stopPropagation()}
        />
      </ChildAccordionSummary>

      <ChildAccordionDetails>
        {fieldGroups.map((group, index) => (
          <CheckboxGroup
            key={group.title || `group-${index}`}
            title={group.title}
            options={group.options}
            selectedValues={group.selectedValues}
            onChangeHandler={group.onChangeHandler}
            isLast={group.isLast}
          />
        ))}
      </ChildAccordionDetails>
    </StyledChildAccordion>
  );
};
